<div class="chartContainer">
  <canvas baseChart width="400" height="400"
    [datasets]="radarChartData"
    [options]="radarChartOptions"
    [labels]="radarChartLabels"
    [chartType]="radarChartType">
  </canvas>
</div>
